import { Button } from "PFComponents/button";
import { LoadingDots } from "PFComponents/loading_dots";
import { Typography } from "PFComponents/typography";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "../localisation_export.module.scss";

type ImportInProgressProps = {
  onClose?: () => void;
};

export const ImportInProgress = ({ onClose }: ImportInProgressProps) => {
  const { t } = useTranslation(["admin", "translation"]);

  return (
    <section className={css.content}>
      <LoadingDots className={css.loading} circlesEnabled circleSize="xs" />
      <Typography variant="h4" noMargin>
        {t("admin:localisation.importModal.analysing")}
      </Typography>
      <Typography variant="bodyRegular" noMargin>
        {t("admin:localisation.importModal.analysingPlaceholder")}
      </Typography>
      <Button kind="tertiary" text={t("translation:close")} onClick={onClose} />
    </section>
  );
};
